import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'title',
    standalone: true,
})
export class TitlePipe implements PipeTransform {
    /**
     * The function transforms a string by capitalizing the first letter.
     *
     * @param {string} value - The `value` parameter in the `transform` function is a string that
     * represents the input value that will be transformed.
     *
     * @returns The `transform` function takes a string as input and returns the same string with the first
     * letter capitalized.
     *
     * @example converts string "my title" to string "My title"
     */
    public transform(value: string | null | undefined): string | null | undefined {
        if (!value) {
            return value;
        }

        return value.substring(0, 1).toUpperCase() + value.substring(1);
    }
}
